import Dexie from "dexie";
import { translate } from "./localization";
const db = new Dexie("EverlongQuest");
const bootUp = async () => {
  try {
    await db.version(1).stores({
      items: `id,value`,
    });
    const value = JSON.stringify({
      countDiamonds: 0,
      collectedDiamonds: 0,
      countEnemies: 0,
      killedEnemies: 0,
      countShrooms: 0,
      collectedShrooms: 0,
      comp: 1,
      prevBest: 0,
    })
    await db.items.bulkPut([
      { id: "totalShroomsAmount", value: JSON.stringify(0) },
      { id: "tripDone", value: JSON.stringify(false) },
      // { id: "level_1", value },
      // { id: "level_2", value },
      // { id: "level_3", value },
      // { id: "level_4", value },
      // { id: "level_5", value },
      // { id: "level_6", value },
      // { id: "level_7", value },
      // { id: "level_8", value },
      // { id: "level_9", value },
      // { id: "level_10", value },
      // { id: "level_11", value },
      // { id: "level_12", value },
      // { id: "level_13", value },
      // { id: "level_14", value },
      // { id: "level_15", value },
      // { id: "level_16", value },
      // { id: "level_17", value },
      // { id: "level_18", value },
      // { id: "maze_1", value },
      // { id: "maze_2", value },
      
    ]);
  } catch (e) {
    alert(translate("menu.cookies.thirdparty"));
    console.error(e);
  }
};

// const DB_NAME = 'data'
// const DB_INITIAL_STATE = {
//   totalShroomsAmount: 0,
//   tripDone: false,
// }

// let memDB = DB_INITIAL_STATE
// const bootUp = () => {
//   const stored = window.localStorage.getItem(DB_NAME) || ''
//   memDB = stored !== '' ? JSON.parse(stored) : DB_INITIAL_STATE
//   return memDB
// }
// const persist = () => window.localStorage.setItem(DB_NAME, JSON.stringify(memDB))

const get = async (key) => {
  const collection = await db.items.where({ id: key });
  const record =
    (await collection.count()) > 0 ? await collection.first() : null;
  return record !== null ? JSON.parse(record.value) : null;
};
const set = async (key, value) => {
  const res = await db.items.where({ id: key }).toArray();
  if (res.length > 0) {
    await db.items.where({ id: key }).modify({ value: JSON.stringify(value) });
  } else {
    // await db.items.add({ value: JSON.stringify(value) }, key)
    // await db.items.put(JSON.stringify(value), key)
    await db.items.put({ id: key, value: JSON.stringify(value) });
  }
  return true;
};
// const get = key => eval(`memDB.${key}`)
// const set = (key, value) => {
//   switch(typeof value) {
//     case 'string':
//       safeSet(key, `\`${value}\``)
//       break
//     case 'number':
//     case 'boolean':
//       safeSet(key, value)
//       break
//     default:
//     case 'object':
//       safeSet(key, `JSON.parse(\`${JSON.stringify(value)}\`)`)
//       break
//   }
//   persist()
// }
const reset = () => {
  db.items.clear();
  // memDB = DB_INITIAL_STATE
  // persist()
};

// const safeSet = (key, value) => eval(`memDB.${key} = ${value}`)
const getLevels = () => {
  const levels = db.items.where("id").startWith("level_").toArray();
  console.log(levels);
  return levels.map((l) => JSON.parse(l));
  // return Object.keys(memDB).map(k => k.includes('level_') ? memDB[k] : null).filter(Boolean)
};
export default {
  bootUp,
  get,
  set,
  reset,
  getLevels,
};
